// Snel toevoegen vanaf DD-productkaarten (alleen producten met één variant)
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-dd-add]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  btn.disabled = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(btn.dataset.ddAdd), quantity: 1 }] })
  })
    .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function () { window.location.href = root + 'cart'; })
    .catch(function () { btn.disabled = false; window.location.href = btn.closest('.dd-card').querySelector('.dd-card__title').href; });
});

// Staffelkeuze (1 stuk / 2 stuks) altijd gelijk aan het aantal dat in de winkelwagen gaat
(function () {
  function sync() {
    var active = document.querySelector('.qb-wrapper .qb-option.qb-active');
    if (!active) return;
    var qty = parseInt(active.dataset.qty, 10) || 1;
    document.querySelectorAll('product-form input[name="quantity"]').forEach(function (i) { i.value = qty; });
  }
  document.addEventListener('qb:state-changed', sync);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.qb-option')) setTimeout(sync, 0);
    if (e.target.closest('.product-form__submit, .sticky-atc button')) sync();
  }, true);
  document.addEventListener('submit', sync, true);
  if (document.readyState !== 'loading') setTimeout(sync, 300); else document.addEventListener('DOMContentLoaded', function () { setTimeout(sync, 300); });
})();

// Verberg een tussenkop (bijv. "Kies je maat:") als er niets onder staat
(function () {
  function tidy() {
    document.querySelectorAll('.main-product__info-container .product-info__image-block').forEach(function (el) {
      var n = el.nextElementSibling;
      while (n && (/^(STYLE|SCRIPT|NOSCRIPT)$/.test(n.tagName) || n.offsetHeight === 0)) n = n.nextElementSibling;
      if (!n || n.classList.contains('product-info__image-block')) el.style.display = 'none';
    });
  }
  if (document.readyState !== 'loading') tidy(); else document.addEventListener('DOMContentLoaded', tidy);
})();

// Kortingscode uit een link (?discount=CODE, ?code=CODE of /discount/CODE) automatisch in de winkelwagen toepassen
(function () {
  var KEY = 'dd_discount';
  function getCookie(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
  function stored() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
  function store(c) { try { localStorage.setItem(KEY, c); } catch (e) {} }
  var q = new URLSearchParams(location.search);
  var fromUrl = (q.get('discount') || q.get('code') || '').trim();
  if (fromUrl) store(fromUrl.toUpperCase());
  var cookieCode = getCookie('discount_code');
  if (!stored() && cookieCode) store(cookieCode.toUpperCase());
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;
  function refreshDrawer() {
    return fetch(location.pathname + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (s) {
      if (!s['cart-drawer']) return;
      var doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
      var n = doc.querySelector('.drawer__inner'), c = document.querySelector('cart-drawer .drawer__inner');
      if (n && c) c.innerHTML = n.innerHTML;
    }).catch(function () {});
  }
  function ensure() {
    var code = stored();
    if (!code || busy) return;
    busy = true;
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.item_count) return;
      var has = (cart.discount_codes || []).some(function (d) { return (d.code || '').toUpperCase() === code; });
      if (has) return;
      return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) })
        .then(function () { return window.ddCartRefresh ? window.ddCartRefresh() : refreshDrawer(); });
    }).catch(function () {}).then(function () { busy = false; });
  }
  if (document.readyState !== 'loading') ensure(); else document.addEventListener('DOMContentLoaded', ensure);
  // na toevoegen aan winkelwagen opnieuw controleren
  var t;
  var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(ensure, 600); });
  function watch() { var d = document.querySelector('cart-drawer'); if (d) mo.observe(d, { childList: true, subtree: true }); }
  if (document.readyState !== 'loading') watch(); else document.addEventListener('DOMContentLoaded', watch);
})();

// Kortingscodeveld in de winkelwagen-la
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nl = (document.documentElement.lang || '').indexOf('nl') === 0;
  var de = (document.documentElement.lang || '').indexOf('de') === 0;
  function money(c) { return '€ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';
  var lastNote = null;
  function decorate(cart, note) {
    var f = document.querySelector('cart-drawer [data-dd-codeform]');
    if (!f) return;
    var old = f.parentNode.querySelector('.dd-code'); if (old) old.remove();
    var msg = f.querySelector('[data-dd-code-msg]');
    var dc = (cart.discount_codes || []).filter(function (d) { return d.applicable; })[0];
    if (dc) {
      var saved = (cart.original_total_price || 0) - (cart.total_price || 0);
      var b = document.createElement('div'); b.className = 'dd-code';
      b.innerHTML = ICON + '<span>' + (nl ? 'Kortingscode <b>' + esc(dc.code) + '</b> is toegepast' + (saved > 0 ? ' — je bespaart <b>' + money(saved) + '</b>' : '') : de ? 'Rabattcode <b>' + esc(dc.code) + '</b> ist eingelöst' + (saved > 0 ? ' — du sparst <b>' + money(saved) + '</b>' : '') : 'Code <b>' + esc(dc.code) + '</b> applied' + (saved > 0 ? ' — you save <b>' + money(saved) + '</b>' : '')) + '</span>';
      var r = document.createElement('button'); r.type = 'button'; r.className = 'dd-codeform__remove'; r.setAttribute('data-dd-code-remove', ''); r.textContent = nl ? 'Verwijderen' : de ? 'Entfernen' : 'Remove';
      b.appendChild(r);
      f.parentNode.insertBefore(b, f);
      f.querySelector('input').value = dc.code;
    }
    if (note) { lastNote = { t: Date.now(), v: note }; }
    else if (lastNote && Date.now() - lastNote.t < 8000) { note = lastNote.v; }
    if (note && msg) { msg.hidden = false; msg.textContent = note; codeOpen(f, true); } else if (msg) { msg.hidden = true; }
  }
  // 30-10-2026: codeveld zit achter het linkje "Kortingscode?" (opgeschoond zoals Zelesta)
  function codeOpen(f, on) {
    f.hidden = !on;
    var t = f.parentNode.querySelector('[data-dd-codetoggle]');
    if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-dd-codetoggle]');
    if (!t) return;
    var f = document.querySelector('cart-drawer [data-dd-codeform]');
    if (!f) return;
    codeOpen(f, f.hidden);
    if (!f.hidden) f.querySelector('input').focus();
  });
  function refresh(note) {
    return fetch(location.pathname + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (s) {
      if (s['cart-drawer']) {
        var doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
        var n = doc.querySelector('.drawer__inner'), c = document.querySelector('cart-drawer .drawer__inner');
        if (n && c) c.innerHTML = n.innerHTML;
      }
      return fetch(root + 'cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) { decorate(cart, note); });
  }
  window.ddCartRefresh = refresh;
  function setCode(code) {
    return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) }).then(function (r) { return r.json(); });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-dd-codeform]');
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button[type=submit]');
    var code = (f.querySelector('input').value || '').trim().toUpperCase();
    if (!code) return;
    btn.disabled = true;
    setCode(code).then(function (cart) {
      var dc = (cart.discount_codes || []).filter(function (d) { return (d.code || '').toUpperCase() === code; })[0];
      if (dc && dc.applicable) { lastNote = null; try { localStorage.setItem('dd_discount', code); } catch (err) {} return refresh(); }
      var staffel = (cart.items || []).some(function (i) { return (i.line_level_discount_allocations || []).some(function (a) { return a.discount_application && a.discount_application.type !== 'discount_code'; }); });
      var sub = (cart.items_subtotal_price || cart.original_total_price || 0) / 100;
      var msg;
      if (dc && staffel) msg = nl ? 'Je krijgt al staffelkorting op je bestelling. Code ' + code + ' is niet te combineren met die korting, dus je houdt het voordeligste: de staffelkorting.' : de ? 'Du bekommst bereits einen Mengenrabatt auf deine Bestellung. Der Code ' + code + ' lässt sich damit nicht kombinieren, daher behältst du den günstigsten Vorteil: den Mengenrabatt.' : 'You already get a quantity discount. Code ' + code + ' cannot be combined with it, so you keep the best deal.';
      else if (dc && sub < 50) msg = nl ? 'Code ' + code + ' geldt vanaf € 50. Voeg nog € ' + (50 - sub).toFixed(2).replace('.', ',') + ' toe aan je winkelwagen.' : de ? 'Der Code ' + code + ' gilt ab 50 €. Füge noch ' + (50 - sub).toFixed(2).replace('.', ',') + ' € zu deinem Warenkorb hinzu.' : 'Code ' + code + ' applies from € 50. Add € ' + (50 - sub).toFixed(2) + ' more to your cart.';
      else if (dc) msg = nl ? 'Code ' + code + ' geldt niet voor de producten in je winkelwagen.' : de ? 'Der Code ' + code + ' gilt nicht für die Artikel in deinem Warenkorb.' : 'Code ' + code + ' does not apply to the items in your cart.';
      else msg = nl ? 'Code ' + code + ' bestaat niet of is verlopen.' : de ? 'Der Code ' + code + ' existiert nicht oder ist abgelaufen.' : 'Code ' + code + ' does not exist or has expired.';
      return setCode('').then(function () { return refresh(msg); });
    }).catch(function () { btn.disabled = false; });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-dd-code-remove]')) return;
    e.preventDefault();
    try { localStorage.removeItem('dd_discount'); } catch (err) {}
    setCode('').then(function () { return refresh(); });
  });
  // telkens als de la opnieuw gevuld wordt: melding bijwerken
  var t, mo = new MutationObserver(function () {
    var f = document.querySelector('cart-drawer [data-dd-codeform]');
    if (!f || f.dataset.ddDone) return;
    f.dataset.ddDone = '1';
    clearTimeout(t); t = setTimeout(function () { fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { decorate(c); }); }, 150);
  });
  function watch() { var d = document.querySelector('cart-drawer'); if (d) mo.observe(d, { childList: true, subtree: true }); }
  if (document.readyState !== 'loading') watch(); else document.addEventListener('DOMContentLoaded', watch);
})();

// Mega menu: openen bij hover (desktop) of klik, sluiten met Esc / klik buiten
(function () {
  function init() {
    var nav = document.querySelector('[data-dd-mega]');
    if (!nav) return;
    var desktop = window.matchMedia('(min-width: 990px)');
    var bd = document.createElement('div'); bd.className = 'dd-mega-backdrop'; document.body.appendChild(bd);
    var open = null, tOpen, tClose;
    function show(id) {
      if (!desktop.matches) return false;
      clearTimeout(tClose);
      if (open === id) return true;
      nav.querySelectorAll('[data-dd-mega-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-dd-mega-panel') !== id; });
      nav.querySelectorAll('[data-dd-mega-top]').forEach(function (a) { a.setAttribute('aria-expanded', a.getAttribute('data-dd-mega-top') === id ? 'true' : 'false'); });
      bd.classList.add('is-on'); open = id; return true;
    }
    function hide() {
      nav.querySelectorAll('[data-dd-mega-panel]').forEach(function (p) { p.hidden = true; });
      nav.querySelectorAll('[data-dd-mega-top]').forEach(function (a) { a.setAttribute('aria-expanded', 'false'); });
      bd.classList.remove('is-on'); open = null;
    }
    nav.querySelectorAll('[data-dd-mega-top]').forEach(function (a) {
      var id = a.getAttribute('data-dd-mega-top');
      a.addEventListener('mouseenter', function () { clearTimeout(tOpen); tOpen = setTimeout(function () { show(id); }, open ? 0 : 120); });
      a.addEventListener('mouseleave', function () { clearTimeout(tOpen); });
      a.addEventListener('click', function (e) { if (desktop.matches && open !== id) { e.preventDefault(); show(id); } });
      a.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && desktop.matches && open !== id) { e.preventDefault(); show(id); var f = nav.querySelector('#dd-mega-' + id + ' a'); if (f) f.focus(); } });
    });
    nav.addEventListener('mouseleave', function () { clearTimeout(tOpen); tClose = setTimeout(hide, 220); });
    nav.addEventListener('mouseenter', function () { clearTimeout(tClose); });
    bd.addEventListener('click', hide);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) hide(); });
    desktop.addEventListener && desktop.addEventListener('change', hide);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

// Filter in Dekbed Discounter-stijl: aantallen, kleurbolletjes, "Bekijk alles", direct toepassen
(function () {
  var COLORS = { 'antraciet':'#3b3b3b','zwart':'#111','wit':'#fff','gebroken wit':'#f4efe6','beige':'#ece2cc','zand':'#d9c7a7','taupe':'#8b7d72','grijs':'#8e8e8e','lichtgrijs':'#c8c8c8','donkergrijs':'#555','zilvergrijs':'#b7b9bb','zilver':'#c0c0c0','blauw':'#2f5fb3','lichtblauw':'#9cc3e6','donkerblauw':'#1f2f5a','marineblauw':'#1b2a4a','staalblauw':'#7b96ad','groen':'#3e8e4f','donkergroen':'#2f4a35','mosgroen':'#6b7a3a','olijfgroen':'#6b6b3a','saliegroen':'#9cae94','haaggroen':'#5b6b4a','lichtgroen':'#a9cf9a','koraalgroen':'#6fb3a0','roze':'#e8a3b5','oudroze':'#c99a9a','donkerroze':'#b5536f','bordeaux':'#6d1a2b','rood':'#c0282d','bruin':'#6b4a33','chocoladebruin':'#4a2e1f','crème':'#f3e9d2','terracotta':'#c66b3d','geel':'#e6c13d','warmgeel':'#e2b04a','oranje':'#e07b2c','lila':'#b39ccf','paars':'#6d4a8c','steengrijs':'#a59d94','nude':'#e3c4ad','goud':'#c9a227',
    /* Duitse optiewaarden op /de (21-10-2026) */ 'anthrazit':'#3b3b3b','schwarz':'#111','weiß':'#fff','wollweiß':'#f4efe6','gebrochenes weiß':'#f4efe6','grau':'#8e8e8e','hellgrau':'#c8c8c8','dunkelgrau':'#555','silbergrau':'#b7b9bb','silber':'#c0c0c0','blau':'#2f5fb3','hellblau':'#9cc3e6','pastellblau':'#9cc3e6','dunkelblau':'#1f2f5a','marineblau':'#1b2a4a','stahlblau':'#7b96ad','grün':'#3e8e4f','hellgrün':'#a9cf9a','dunkelgrün':'#2f4a35','moosgrün':'#6b7a3a','olivgrün':'#6b6b3a','salbeigrün':'#9cae94','jadegrün':'#6fb3a0','rosa':'#e8a3b5','hellrosa':'#e8a3b5','zartrosa':'#e8a3b5','altrosa':'#c99a9a','dunkelrosa':'#b5536f','rot':'#c0282d','braun':'#6b4a33','hellbraun':'#9b7653','schokobraun':'#4a2e1f','creme':'#f3e9d2','terrakotta':'#c66b3d','gelb':'#e6c13d','warmgelb':'#e2b04a','senfgelb':'#d4a72c','orange':'#e07b2c','lila':'#b39ccf','stein':'#a59d94','champagner':'#e9dcc3','helles taupe':'#b3a596','pastellgrau':'#c8c8c8' };
  window.DD_COLORS = COLORS;
  function init() {
    var side = document.querySelector('.sidebar-filters');
    if (!side) return;
    var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
    var handle = m ? decodeURIComponent(m[1]) : '';
    var cards = [].slice.call(document.querySelectorAll('.product-grid .product-card'));
    var inCol = cards.filter(function (c) { return !handle || (' ' + (c.dataset.collection || '') + ' ').indexOf(' ' + handle + ' ') > -1; });
    var applyBtn = side.querySelector('[data-apply-filters]');
    side.querySelectorAll('.sf-group').forEach(function (g) {
      var opts = [].slice.call(g.querySelectorAll('.sf-option'));
      var shown = 0;
      opts.forEach(function (o) {
        var inp = o.querySelector('input'); if (!inp) return;
        var grp = inp.getAttribute('data-filter-group'), val = inp.value;
        var n = 0;
        if (grp === 'collection' || grp === 'rating') { n = 1; }
        else inCol.forEach(function (c) { if (('|' + (c.dataset.variantOptionsNames || '') + '|').toLowerCase().indexOf('|' + (grp + ':' + val).toLowerCase() + '|') > -1) n++; });
        if (!o.querySelector('.dd-cnt') && grp !== 'collection' && grp !== 'rating') {
          var sp = document.createElement('span'); sp.className = 'dd-cnt'; sp.textContent = '(' + n + ')'; o.appendChild(sp);
        }
        if (grp === 'color' && !o.querySelector('.dd-sw') && !o.querySelector('.sf-dot')) {
          var key = val.toLowerCase().split('/')[0].trim();
          var sw = document.createElement('span'); sw.className = 'dd-sw';
          var c1 = COLORS[key], c2 = COLORS[(val.toLowerCase().split('/')[1] || '').trim()];
          sw.style.background = c2 ? 'linear-gradient(135deg,' + (c1 || '#ddd') + ' 50%,' + c2 + ' 50%)' : (c1 || 'conic-gradient(#e33,#ec3,#3c6,#39e,#a3e,#e33)');
          inp.insertAdjacentElement('afterend', sw);
        }
        o.classList.toggle('dd-zero', n === 0);
        if (n > 0) { shown++; o.classList.toggle('dd-more', shown > 7); }
      });
      if (shown > 7 && !g.querySelector('.dd-showall')) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'dd-showall';
        var nl = (document.documentElement.lang || '').indexOf('nl') === 0;
        var de = (document.documentElement.lang || '').indexOf('de') === 0;
        b.textContent = nl ? 'Bekijk alles' : de ? 'Alle anzeigen' : 'Show all';
        b.addEventListener('click', function () { var on = g.classList.toggle('is-expanded'); b.textContent = on ? (nl ? 'Toon minder' : de ? 'Weniger anzeigen' : 'Show less') : (nl ? 'Bekijk alles' : de ? 'Alle anzeigen' : 'Show all'); });
        (g.querySelector('.sf-group__options') || g).appendChild(b);
      }
      if (shown === 0 && g.querySelector('[data-filter-group]') && !g.querySelector('[data-filter-group="collection"]')) g.style.display = 'none';
    });
    side.addEventListener('change', function (e) { if (e.target.matches('.sf-input') && applyBtn) setTimeout(function () { applyBtn.click(); }, 0); });
  }
  if (document.readyState !== 'loading') setTimeout(init, 400); else document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 400); });
})();

/* ---- Bestelblok: code kopiëren, "Maak het compleet", inschrijf-pop-up ---- */
(function(){
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-dd-copy]');
    if (!b || b.closest('.dd-promo')) return;
    var code = b.getAttribute('data-dd-copy');
    var done = function(){ b.classList.add('is-copied'); setTimeout(function(){ b.classList.remove('is-copied'); }, 1600); };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    try { localStorage.setItem('dd_discount', code); } catch(_){}
  });

  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-dd-x-add]');
    if (!b) return;
    var row = b.closest('[data-dd-x]'), v = row && row.querySelector('[data-dd-x-variant]');
    if (!v || b.disabled) return;
    b.disabled = true; b.classList.add('is-busy');
    var d = document.querySelector('cart-drawer');
    var body = { items:[{ id: +v.value, quantity: +row.getAttribute('data-dd-x-qty') || 1 }] };
    if (d && d.getSectionsToRender) { body.sections = d.getSectionsToRender().map(function(x){ return x.section || x.id; }); body.sections_url = location.pathname; }
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body: JSON.stringify(body) })
      .then(function(r){ if (!r.ok) throw r; return r.json(); })
      .then(function(res){
        b.classList.add('is-added');
        if (d && d.renderContents && res.sections) { try { d.classList.remove('is-empty'); d.renderContents(res); return; } catch(_){} }
        location.href = '/cart';
      })
      .catch(function(){ b.classList.add('is-err'); })
      .finally(function(){ b.disabled = false; b.classList.remove('is-busy'); setTimeout(function(){ b.classList.remove('is-added','is-err'); }, 2000); });
  });

  var su = document.querySelector('[data-dd-signup]');
  if (!su) return;
  var panel = su.querySelector('.dd-su__panel'), ov = su.querySelector('.dd-su__overlay');
  var get = function(k){ try { return localStorage.getItem(k); } catch(_) { return null; } };
  var set = function(k,v){ try { localStorage.setItem(k,v); } catch(_){} };
  // Actie-pop-up (data-campaign, bv. Black Friday bf26) heeft eigen sleutels: wie de gewone pop-up al wegklikte of zich inschreef, ziet hem nog één keer.
  var ck = su.getAttribute('data-campaign'), K = function(k){ return ck ? k + '_' + ck : k; };
  var fine = window.matchMedia && matchMedia('(pointer:fine)').matches;
  function open(auto){ panel.hidden = false; ov.hidden = false; requestAnimationFrame(function(){ su.classList.add('is-open'); }); var i = panel.querySelector('input[type=email]'); if (i && (!auto || fine)) setTimeout(function(){ i.focus(); }, 250); }
  function close(){ su.classList.remove('is-open'); setTimeout(function(){ panel.hidden = true; ov.hidden = true; }, 250); set(K('dd_su_seen'), '1'); }
  if (get(K('dd_su_hidden')) === '1' || get(K('dd_su_done')) === '1') su.classList.add('is-tab-hidden');
  su.addEventListener('click', function(e){
    if (e.target.closest('[data-dd-su-open]')) open();
    else if (e.target.closest('[data-dd-su-close]')) close();
    else if (e.target.closest('[data-dd-su-hide]')) { su.classList.add('is-tab-hidden'); set(K('dd_su_hidden'), '1'); }
  });
  // Knoppen buiten de pop-up (bv. "Haal je code" in de actiebalk) openen hem ook.
  document.addEventListener('click', function(e){ var o = e.target.closest('[data-dd-su-open]'); if (o && !su.contains(o)) { e.preventDefault(); open(); } });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && su.classList.contains('is-open')) close(); });
  if (su.querySelector('[data-dd-su-success]') || su.querySelector('.dd-su__err')) { open(); if (su.querySelector('[data-dd-su-success]')) set(K('dd_su_done'), '1'); }
  else {
    var d = +su.getAttribute('data-delay'), end = +su.getAttribute('data-end') || 0;
    if (d > 0 && !su.hasAttribute('data-noauto') && !get(K('dd_su_seen')) && !get(K('dd_su_done')) && !(end && Date.now() > end)) {
      // Eén keer vanzelf open; wacht zolang de winkelwagen, een ander venster of de cookiebanner open is.
      var fired = false;
      var auto = function(){
        if (fired || su.classList.contains('is-open') || get(K('dd_su_seen'))) return;
        var cb = document.getElementById('shopify-pc__banner');
        if (document.querySelector('cart-drawer.active, cart-drawer[open]') || document.body.classList.contains('overflow-hidden') || (cb && cb.offsetHeight > 0)) { setTimeout(auto, 4000); return; }
        fired = true; set(K('dd_su_seen'), '1'); open(true);
      };
      setTimeout(auto, d * 1000);
      if (su.hasAttribute('data-exit') && fine) setTimeout(function(){ document.addEventListener('mouseout', function(e){ if (!e.relatedTarget && e.clientY <= 0) auto(); }); }, 4000);
    }
  }
})();

/* ---- USP-balk tussen productrijen (collectiepagina) ---- */
(function () {
  var tpl = document.getElementById('dd-strip-tpl');
  var grid = document.querySelector('.collection-grid-section .product-grid');
  if (!tpl || !grid) return;
  var busy = false, t;
  function cols() {
    var c = getComputedStyle(grid).gridTemplateColumns;
    var n = c && c !== 'none' ? c.split(' ').filter(Boolean).length : 0;
    return n || 2;
  }
  function place() {
    busy = true;
    grid.querySelectorAll('.dd-strip').forEach(function (s) { s.remove(); });
    var cards = Array.prototype.filter.call(grid.querySelectorAll('.product-card'), function (c) { return c.style.display !== 'none' && c.offsetParent !== null; });
    var n = cols();
    var first = n * 2, every = n * 6;
    for (var i = first; i < cards.length; i += every) {
      cards[i - 1].after(tpl.content.firstElementChild.cloneNode(true));
    }
    setTimeout(function () { busy = false; }, 0);
  }
  function schedule() { if (busy) return; clearTimeout(t); t = setTimeout(place, 120); }
  new MutationObserver(schedule).observe(grid, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  window.addEventListener('resize', schedule);
  if (document.readyState === 'complete') place(); else window.addEventListener('load', place);
})();

// Kleurbolletjes (kaarten + PDP): kleur uit kaart als er geen Shopify-kleurstaal is; kaartfoto wisselt mee met de gekozen kleur
(function () {
  var EN = {'black':'zwart','white':'wit','anthracite':'antraciet','antra':'antraciet','grey':'grijs','gray':'grijs','navy':'marineblauw','dark blue':'donkerblauw','burgundy':'bordeaux','brugundy':'bordeaux','sand':'zand','blue':'blauw','green':'groen','pink':'roze','old pink':'oudroze','brown':'bruin','cream':'crème','creme':'crème','off white':'gebroken wit','silver grey':'zilvergrijs','silver gray':'zilvergrijs','light grey':'lichtgrijs','light gray':'lichtgrijs','dark grey':'donkergrijs','sage green':'saliegroen','moss green':'mosgroen','yellow':'geel','orange':'oranje','red':'rood','lilac':'lila','purple':'paars','gold':'goud','chocolate':'chocoladebruin','light blue':'lichtblauw','light pink':'roze','marineblauw':'marineblauw'};
  function hex(k) { var C = window.DD_COLORS || {}; k = (k || '').trim(); return C[k] || C[EN[k]] || null; }
  function paint() {
    document.querySelectorAll('.dd-dot:not(.is-fixed):not([data-p])').forEach(function (d) {
      d.setAttribute('data-p', '1');
      var ks = (d.getAttribute('data-dd-dot') || '').split('|'), c = null;
      for (var i = 0; i < ks.length && !c; i++) {
        c = hex(ks[i]);
        if (!c && ks[i].indexOf('/') > -1) { var a = hex(ks[i].split('/')[0]), b = hex(ks[i].split('/')[1]); if (a && b) c = 'linear-gradient(135deg,' + a + ' 50%,' + b + ' 50%)'; }
      }
      if (c) { d.style.backgroundImage = 'none'; d.style.background = c; d.classList.add('is-color'); }
      else if (!d.style.backgroundImage) d.style.background = 'conic-gradient(#e33,#ec3,#3c6,#39e,#a3e,#e33)';
    });
  }
  function pick(btn) {
    var card = btn.closest('.dd-card'); if (!card) return;
    card.classList.add('dd-picked');
    card.querySelectorAll('.dd-dot-btn').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
    var img = card.querySelector('.dd-card__media img:not(.dd-card__alt)'), u = btn.getAttribute('data-img');
    if (img && u && img.getAttribute('src') !== u) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = u; }
    var h = btn.getAttribute('data-href');
    if (h) { card.querySelectorAll('a.dd-card__title, a.dd-add').forEach(function (a) { a.href = h; }); var w = card.closest('[data-product-url]'); if (w) w.setAttribute('data-product-url', h); }
  }
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('.dd-dot-btn'); if (b) { e.preventDefault(); e.stopPropagation(); pick(b); } }, true);
  document.addEventListener('mouseover', function (e) { var b = e.target.closest && e.target.closest('.dd-dot-btn'); if (b && window.matchMedia('(hover: hover)').matches) pick(b); });
  // Hovervideo op productkaarten (17-10-2026): laadt pas bij eerste hover, speelt vertraagd af, stopt bij verlaten
  function vidCard(card, on) {
    var v = card.querySelector('video.dd-card__vid'); if (!v) return;
    if (on) {
      if (!v.getAttribute('src')) { v.src = v.getAttribute('data-src'); }
      v.playbackRate = 0.8;
      var p = v.play(); if (p && p.then) p.then(function () { v.playbackRate = 0.8; card.classList.add('is-playing'); }).catch(function () {}); else card.classList.add('is-playing');
    } else { card.classList.remove('is-playing'); v.pause(); }
  }
  document.addEventListener('mouseover', function (e) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    var c = e.target.closest && e.target.closest('.dd-card--vid'); if (!c || c.contains(e.relatedTarget)) return; vidCard(c, true);
  });
  document.addEventListener('mouseout', function (e) {
    var c = e.target.closest && e.target.closest('.dd-card--vid'); if (!c || c.contains(e.relatedTarget)) return; vidCard(c, false);
  });
  // Upsell (bijv. topper → bijpassend dekbed): volgt de gekozen kleur op de PDP
  function syncUpsell(val) {
    var sel = document.querySelector('[data-dd-x-match] select[data-dd-x-variant]'); if (!sel || !val) return;
    val = val.toLowerCase();
    var o = [].find.call(sel.options, function (x) { return x.getAttribute('data-c') === val || x.getAttribute('data-cl') === val; }); if (!o) return;
    sel.value = o.value;
    var im = sel.closest('[data-dd-x]').querySelector('[data-dd-x-img]'); if (im && o.getAttribute('data-img')) im.src = o.getAttribute('data-img');
  }
  // Hoeslaken-upsells (19-10-2026): volgen de gekozen breedte (80/90, 140, 160/180 …) van het hoofdproduct
  function syncWidth(val) {
    var ws = String(val || '').split('x')[0].split('/').map(function (s) { return s.trim(); }).filter(Boolean); if (!ws.length) return;
    document.querySelectorAll('[data-dd-x-w] select[data-dd-x-variant]').forEach(function (sel) {
      var o = [].find.call(sel.options, function (x) { var w = x.getAttribute('data-w') || ''; return ws.some(function (n) { return w.indexOf(' ' + n + ' ') > -1; }); }); if (!o) return;
      sel.value = o.value;
      var im = sel.closest('[data-dd-x]').querySelector('[data-dd-x-img]'); if (im && o.getAttribute('data-img')) im.src = o.getAttribute('data-img');
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('select[data-dd-x-variant]')) { var o = t.options[t.selectedIndex], im = t.closest('[data-dd-x]').querySelector('[data-dd-x-img]'); if (o && im && o.getAttribute('data-img')) im.src = o.getAttribute('data-img'); return; }
    if (t.matches && t.matches('input[type=radio]') && /^(color|colour|kleur|farbe|motiv|design|dessin|print)/i.test(t.name || '')) syncUpsell(t.value);
    if (t.matches && t.matches('input[type=radio]') && /^(size|maat|afmeting|größe|grösse)/i.test(t.name || '')) syncWidth(t.value);
  });
  var tm; function later() { clearTimeout(tm); tm = setTimeout(paint, 60); }
  if (document.readyState !== 'loading') paint(); else document.addEventListener('DOMContentLoaded', paint);
  new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Cadeau bij aankoop (16-10-2026): voegt het cadeau automatisch toe of haalt het weg.
   Regels komen uit #dd-gifts (snippets/dd-gifts.liquid); de Shopify-korting maakt het cadeau gratis. */
(function () {
  var el = document.getElementById('dd-gifts');
  if (!el || window.__ddGifts) return;
  window.__ddGifts = true;
  var rules;
  var nowS = Date.now() / 1000;
  try { rules = JSON.parse(el.textContent).filter(function (r) { return r.variant && ((r.triggers && r.triggers.length) || r.min) && !(r.end && nowS > r.end); }); } catch (e) { return; }
  if (!rules.length) return;
  var busy = false, again = false, timer = null, steps = 0, pause = false;
  // Cadeau met kleurkeuze (o4, 23-10-2026): de gekozen kleur onthouden we per sessie.
  function picked(rule) {
    if (!rule.pick) return rule.variant;
    var v = 0;
    try { v = Number(sessionStorage.getItem('dd_gift_pick_' + rule.id) || 0); } catch (e) {}
    return v || rule.variant;
  }
  var origFetch = window.fetch;
  function isCartMut(u) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u); }
  function drawer() { return document.querySelector('cart-drawer'); }
  function post(url, body) {
    var d = drawer();
    if (d && d.getSectionsToRender) { body.sections = d.getSectionsToRender().map(function (x) { return x.section || x.id; }); body.sections_url = location.pathname; }
    return origFetch.call(window, url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.ok ? r.json() : null; });
  }
  function render(res) {
    var d = drawer();
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    if (d && d.renderContents && res && res.sections) { try { d.classList.remove('is-empty'); d.renderContents(res); } catch (e) {} }
  }
  function isGift(it) { return !!(it.properties && it.properties._dd_gift); }
  // Shopify kiest zelf de voordeligste combinatie (cadeau óf staffelkorting). Een cadeau dat Shopify niet gratis maakt,
  // halen we weer weg en voegen we voor deze samenstelling van de winkelwagen niet opnieuw toe.
  var suppressed = {};
  try { suppressed = JSON.parse(sessionStorage.getItem('dd_gift_sup') || '{}'); } catch (e) {}
  function sig(cart) {
    return cart.items.filter(function (it) { return !isGift(it); }).map(function (it) { return it.variant_id + ':' + it.quantity; }).sort().join(',');
  }
  function saveSup() { try { sessionStorage.setItem('dd_gift_sup', JSON.stringify(suppressed)); } catch (e) {} }
  // Cadeauregels die (deels) betaald zijn: terugbrengen naar het aantal dat Shopify echt gratis maakt.
  function unpaid(cart) {
    var s = sig(cart), op = null;
    cart.items.some(function (it) {
      if (!isGift(it) || it.final_line_price <= 0) return false;
      var free = it.price > 0 ? Math.floor((it.original_line_price - it.final_line_price) / it.price + 0.0001) : it.quantity;
      free = Math.max(0, Math.min(it.quantity, free));
      suppressed[String(it.product_id)] = s; saveSup();
      op = ['/cart/change.js', { id: it.key, quantity: free }];
      return true;
    });
    return op;
  }
  // Per cadeauproduct: gewenst aantal (som van de regels) vs. aanwezig (alle regels van dat product, ook zelf toegevoegd).
  // Alleen automatisch toegevoegde regels (_dd_gift) worden ooit verminderd of verwijderd.
  function plan(cart) {
    var groups = {}, order = [];
    rules.forEach(function (rule) {
      var key = String(rule.gift || rule.variant);
      if (!groups[key]) { groups[key] = { want: 0, variant: picked(rule), id: rule.id }; order.push(key); }
      var want = 0;
      if (rule.min) {
        var sub = 0;
        cart.items.forEach(function (it) {
          if (isGift(it) || String(it.product_id) === key) return;
          if (rule.excl && rule.excl.indexOf(it.product_id) !== -1) return;
          if (rule.incl && rule.incl.indexOf(it.product_id) === -1) return;
          sub += it.final_line_price;
        });
        want = sub >= rule.min ? rule.per : 0;
      } else {
        var trig = 0;
        cart.items.forEach(function (it) { if (!isGift(it) && rule.triggers && rule.triggers.indexOf(it.product_id) !== -1) trig += it.quantity; });
        want = trig * rule.per;
      }
      if (rule.max) want = Math.min(want, rule.max);
      groups[key].want += want;
    });
    var op = null;
    order.some(function (key) {
      var g = groups[key], have = 0, lines = [];
      cart.items.forEach(function (it) {
        if (String(it.product_id) === key || (!rules[0].gift && it.variant_id === g.variant)) { have += it.quantity; if (isGift(it)) lines.push(it); }
      });
      if (g.want > have && suppressed[key] !== sig(cart)) op = ['/cart/add.js', { items: [{ id: g.variant, quantity: g.want - have, properties: { _dd_gift: g.id } }] }];
      else if (g.want < have && lines.length) {
        var line = lines[0], excess = Math.min(have - g.want, line.quantity);
        op = ['/cart/change.js', { id: line.key, quantity: line.quantity - excess }];
      }
      return !!op;
    });
    return op;
  }
  function schedule(reset) { if (reset) steps = 0; clearTimeout(timer); timer = setTimeout(sync, 350); }
  // Kleur van het cadeau wisselen in de winkelwagen (knoppen uit cart-drawer.liquid, [data-dd-giftpick]).
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-dd-giftpick] [data-variant]') : null;
    if (!b || b.disabled || b.classList.contains('is-on')) return;
    var box = b.closest('[data-dd-giftpick]');
    var v = Number(b.getAttribute('data-variant')), key = box.getAttribute('data-line-key');
    var q = Number(box.getAttribute('data-qty') || 1), gid = box.getAttribute('data-gift-id') || 'o4';
    if (!v || !key || pause) return;
    e.preventDefault();
    try { sessionStorage.setItem('dd_gift_pick_' + gid, String(v)); } catch (x) {}
    pause = true;
    box.classList.add('is-busy');
    post('/cart/change.js', { id: key, quantity: 0 })
      .then(function () { return post('/cart/add.js', { items: [{ id: v, quantity: q, properties: { _dd_gift: gid } }] }); })
      .then(function (res) {
        if (res) render(res);
        else { try { sessionStorage.removeItem('dd_gift_pick_' + gid); } catch (x) {} }
      })
      .catch(function () {})
      .then(function () { pause = false; schedule(true); });
  });
  function sync() {
    if (pause) return;
    if (busy) { again = true; return; }
    if (steps >= 4) return;
    busy = true;
    origFetch.call(window, '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var op = unpaid(cart) || plan(cart);
        if (!op) return;
        steps++;
        return post(op[0], op[1]).then(function (res) { if (res) { render(res); again = true; } });
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; schedule(false); } });
  }
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (isCartMut(url)) p.then(function () { schedule(true); }, function () {});
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (isCartMut(String(u))) this.addEventListener('load', function () { schedule(true); });
    return xo.apply(this, arguments);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(true); });
  else schedule(true);
})();

/* Cadeau-actie-timer in de winkelwagen (16-10-2026): telt af naar data-dd-gt (unix-seconden, uit dd-gifts.liquid).
   De la wordt steeds opnieuw opgebouwd, dus elke seconde alle timers opnieuw opzoeken. Na afloop verdwijnt de balk. */
(function () {
  if (window.__ddGiftTimer) return;
  window.__ddGiftTimer = true;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var els = document.querySelectorAll('[data-dd-gt]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], end = +el.getAttribute('data-dd-gt') * 1000, d = end - Date.now();
      if (!(d > 0)) { el.hidden = true; continue; }
      var s = Math.floor(d / 1000);
      el.querySelector('[data-d]').textContent = Math.floor(s / 86400);
      el.querySelector('[data-h]').textContent = pad(Math.floor(s % 86400 / 3600));
      el.querySelector('[data-m]').textContent = pad(Math.floor(s % 3600 / 60));
      el.querySelector('[data-s]').textContent = pad(s % 60);
      el.classList.add('is-on');
    }
  }
  tick();
  setInterval(tick, 1000);
})();

/* Reserveringstimer winkelwagen (16-10-2026, op verzoek Max, zoals HappyBed; 30-10 terug na "zet de oude cartdrawer weer terug"): 10 minuten vanaf de eerste toevoeging.
   Attribuut data-dd-resv (was data-dd-rt; die naam gebruikt de retourpagina ook).
   Na afloop staat er "verlopen"; de volgende wijziging in de winkelwagen start een nieuwe periode. Bij leegmaken stopt hij. */
(function () {
  if (window.__ddResv) return;
  window.__ddResv = true;
  var K = 'dd_resv_until', MS = 10 * 60 * 1000, mem = 0;
  function get() { try { return +localStorage.getItem(K) || 0; } catch (e) { return mem; } }
  function set(v) { mem = v; try { localStorage.setItem(K, String(v)); } catch (e) {} }
  function start() { var u = get(); if (!u || u < Date.now()) set(Date.now() + MS); }
  function onUrl(u) {
    if (/\/cart\/clear/.test(u)) set(0);
    else if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(u)) start();
  }
  var of = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = of.apply(this, arguments);
    p.then(function () { onUrl(url); }, function () {});
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    var url = String(u);
    this.addEventListener('load', function () { onUrl(url); });
    return xo.apply(this, arguments);
  };
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var els = document.querySelectorAll('[data-dd-resv]');
    if (!els.length) return;
    if (!get()) start();
    var d = get() - Date.now(), s = Math.max(0, Math.ceil(d / 1000));
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.hidden = false;
      el.classList.toggle('is-exp', !(d > 0));
      var m = el.querySelector('[data-rm]'), sc = el.querySelector('[data-rs]');
      if (m) m.textContent = pad(Math.floor(s / 60));
      if (sc) sc.textContent = pad(s % 60);
    }
  }
  tick();
  setInterval(tick, 1000);
})();

/* GLIDE-stijl productpagina (16-10-2026): fotokop in de eerste galerijfoto + levertijdlijn met echte datums. */
(function () {
  if (window.__ddGlide) return;
  window.__ddGlide = true;
  function firstMedia() {
    var list = document.querySelector('.product__media-wrapper .product__media-list');
    if (!list) return null;
    var items = list.querySelectorAll('li.product__media-item');
    for (var i = 0; i < items.length; i++) { if (items[i].offsetParent !== null || i === items.length - 1) return items[i]; }
    return items[0] || null;
  }
  function placeHero() {
    var src = document.querySelector('[data-dd-gh]');
    if (!src) return;
    var li = firstMedia();
    if (!li || li.querySelector('.dd-gh')) return;
    var box = li.querySelector('.product__media, .product-media-container, .media') || li;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var c = src.cloneNode(true);
    c.removeAttribute('data-dd-gh');
    c.hidden = false;
    box.appendChild(c);
  }
  /* A+-fototeksten (16-10-2026): foto 1 = probleem → oplossing (tenzij handgeschreven kop), volgende foto's om de beurt een USP. Data: script[data-dd-aplus] (snippets/dd-aplus-data.liquid). Alleen een laag over de foto; de beeldbestanden blijven schoon. */
  function apData() {
    var s = document.querySelector('script[data-dd-aplus]');
    if (!s) return null;
    try { var d = JSON.parse(s.textContent); return d && d.usp && d.usp.length ? d : null; } catch (e) { return null; }
  }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function acc(t) { return esc(t).replace(/\*([^*]+)\*/g, '<em class="dd-accent">$1</em>'); }
  function placeAplus() {
    var d = apData();
    var list = document.querySelector('.product__media-wrapper .product__media-list');
    if (!d || !list) return;
    var hand = !!document.querySelector('[data-dd-gh][data-hand]');
    var items = list.querySelectorAll('li.product__media-item');
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      if (li.querySelector('.dd-gh') || li.querySelector('video, iframe, model-viewer, deferred-media')) continue;
      if (li.querySelector('img[src*="zy-uitleg-"]')) continue; // uitlegbeeld heeft zijn tekst al in het beeld (30-10-2026)
      if (i === 0 && hand) continue;
      var box = li.querySelector('.product__media, .product-media-container, .media') || li;
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      var el = document.createElement('div');
      el.setAttribute('aria-hidden', 'true');
      if (i === 0) {
        el.className = 'dd-gh dd-gh--ap';
        el.innerHTML = '<div class="dd-gh__in">' + (d.p ? '<p class="dd-gh__p">' + esc(d.p) + '</p>' : '') + '<p class="dd-gh__h">' + acc(d.s) + '</p>' +
          (d.n ? '<div class="dd-gh__spec' + (String(d.n).length > 4 ? ' dd-gh__spec--long' : '') + '"><b>' + esc(d.n) + (d.u ? '<i>' + esc(d.u) + '</i>' : '') + '</b>' + (d.c ? '<span>' + esc(d.c) + '</span>' : '') + '</div>' : '') + '</div>';
      } else {
        var u = d.usp[(i - 1) % d.usp.length];
        el.className = 'dd-gh dd-gh--ap dd-gh--usp';
        el.innerHTML = '<div class="dd-gh__in">' + (u.q ? '<p class="dd-gh__p">' + esc(u.q) + '</p>' : '') + '<p class="dd-gh__h">' + acc(u.t) + '</p>' + (u.x ? '<p class="dd-gh__x">' + esc(u.x) + '</p>' : '') + '</div>';
      }
      box.appendChild(el);
    }
  }
  function addWd(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function fmt(d, nl) { return d.toLocaleDateString(nl ? 'nl-NL' : ((document.documentElement.lang || '').indexOf('de') === 0 ? 'de-DE' : 'en-GB'), { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, ''); }
  function delivery() {
    var els = document.querySelectorAll('[data-dd-gd]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], nl = el.getAttribute('data-nl') === 'true', lev = el.getAttribute('data-lev') || '', now = new Date();
      var nums = lev.match(/\d+/g), d1 = el.querySelector('[data-d1]'), d2 = el.querySelector('[data-d2]');
      if (/wee?k/i.test(lev) && nums) {
        var a = +nums[0], b = +(nums[1] || nums[0]);
        var ship = el.querySelector('[data-dd-gd-ship]');
        if (ship) ship.remove();
        el.classList.add('is-2');
        d2.textContent = fmt(addDays(now, a * 7), nl) + ' – ' + fmt(addDays(now, b * 7), nl);
      } else {
        d1.textContent = fmt(addWd(now, 2), nl) + ' – ' + fmt(addWd(now, 4), nl);
        d2.textContent = fmt(addWd(now, 3), nl) + ' – ' + fmt(addWd(now, 5), nl);
      }
    }
  }
  // 30-10-2026 (Max: "zorg dat het filmpje altijd al afspeelt gelijk"): galerijvideo's starten bij het laden, gedempt en in een lus,
  // niet pas als ze in beeld scrollen (internal-video in main.js laadt ze anders pas bij zichtbaarheid en begint dan opnieuw).
  function playNow() {
    document.querySelectorAll('.product__media-wrapper internal-video[data-autoplay="true"]').forEach(function (iv) {
      var v = iv.querySelector('video');
      if (!v || iv.__ddPlay) return;
      iv.__ddPlay = 1;
      if (iv.observer) iv.observer.disconnect();
      v.querySelectorAll('source[data-src]').forEach(function (s) { s.setAttribute('src', s.getAttribute('data-src')); s.removeAttribute('data-src'); });
      v.muted = true; v.loop = true; v.setAttribute('playsinline', ''); v.preload = 'auto';
      v.load();
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  }
  function init() {
    placeAplus();
    placeHero();
    delivery();
    playNow();
    var list = document.querySelector('.product__media-wrapper .product__media-list');
    if (list && window.MutationObserver) new MutationObserver(function () { placeAplus(); placeHero(); }).observe(list, { childList: true, subtree: false, attributes: true, attributeFilter: ['class', 'style'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ---- Mobiel: vaste bestelbalk vraagt eerst om een keuze (17-10-2026) ----
   De balk staat op mobiel altijd in beeld (dd-style.css). Zonder keuze zou hij de standaardvariant toevoegen,
   dus bij producten met opties: knop "Kies je maat" → scrollt naar de keuze; na een keuze (of ?variant= in de URL) gewoon toevoegen. */
(function () {
  var bar = document.querySelector('sticky-atc');
  if (!bar) return;
  var btn = bar.querySelector('button.main-product-atc');
  var radios = Array.prototype.filter.call(document.querySelectorAll('.product__info-wrapper input[type=radio]'), function (i) { return !/rating|review/i.test(i.name || ''); });
  if (!btn || !radios.length) return;
  var mq = window.matchMedia('(max-width: 749px)');
  var chosen = /[?&]variant=\d+/.test(location.search);
  var lbl = document.createElement('span');
  lbl.className = 'dd-choose-lbl';
  var dl = document.documentElement.lang || '';
  lbl.textContent = dl.indexOf('nl') === 0 ? 'Kies je maat' : dl.indexOf('de') === 0 ? 'Größe wählen' : 'Choose your size';
  btn.appendChild(lbl);
  function paint() { bar.classList.toggle('dd-sticky-choose', mq.matches && !chosen); }
  paint();
  if (mq.addEventListener) mq.addEventListener('change', paint);
  // Het thema vervangt de keuzeknoppen na een wissel → luisteren op documentniveau
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.type === 'radio' && t.closest('.product__info-wrapper') && !/rating|review/i.test(t.name || '')) { chosen = true; paint(); }
  });
  bar.addEventListener('click', function (e) {
    if (!mq.matches || chosen || !e.target.closest('button.main-product-atc')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var first = Array.prototype.filter.call(document.querySelectorAll('.product__info-wrapper input[type=radio]'), function (i) { return !/rating|review/i.test(i.name || ''); })[0];
    if (!first) return;
    var w = first.closest('.variant-pill-wrapper, fieldset') || first;
    w.scrollIntoView({ behavior: 'smooth', block: 'center' }); // pagina scrolt in body, niet in window
    w.classList.add('dd-pick-hint'); setTimeout(function () { w.classList.remove('dd-pick-hint'); }, 1800);
  }, true);
})();

/* Beter samen (PDP) + Maak je bed compleet (winkelwagen), 27-10-2026 — zie snippets/dd-pairs.liquid.
   Kiest per [data-dd-pair] de variant die past bij de maat in data-ref: dekbed in de maat van het overtrek, overtrek om het
   dekbed (kleur kiezen), kussens in maat en aantal van de slopen in de set. Volgt de maatkeuze op de PDP. */
(function () {
  function sz(s) {
    s = String(s || '').toLowerCase().replace(/\s+/g, '').replace(/cm/g, '');
    var m = s.match(/^(\d+)(?:\/\d+)?x(\d+(?:\/\d+)*)/); if (!m) return null;
    var k = s.match(/\+(\d)[x*](\d+x\d+)/);
    return { w: +m[1], L: m[2].split('/').map(Number), n: k ? +k[1] : 0, k: k ? k[2] : '' };
  }
  function cm(s) { return String(s || '').replace(/\s*cm\s*$/i, '').replace(/^(\d+)x(\d+)$/, '$1 x $2') + ' cm'; }
  function money(row, c) {
    var t = row.getAttribute('data-money') || '€12,34', v = (c / 100).toFixed(2);
    return t.indexOf('12,34') > -1 ? t.replace('12,34', v.replace('.', ',')) : t.replace('12.34', v);
  }
  function lang() { var l = (document.documentElement.lang || 'nl').slice(0, 2); return l === 'de' || l === 'en' ? l : 'nl'; }
  function vars(row) { if (!row.__v) { try { row.__v = JSON.parse(row.querySelector('[data-dd-px-vars]').textContent); } catch (e) { row.__v = []; } } return row.__v; }
  function opt(sel, x, txt) { var o = document.createElement('option'); o.value = x.id; o.textContent = txt; o.setAttribute('data-img', x.img || ''); o.setAttribute('data-c', x.c || ''); o.__x = x; sel.appendChild(o); }
  function show(row, x, qty) {
    var inp = row.querySelector('[data-dd-x-variant]'), im = row.querySelector('[data-dd-x-img]'), pr = row.querySelector('[data-dd-x-price]');
    if (inp && inp.tagName !== 'SELECT') inp.value = x.id;
    if (im && x.img) im.src = x.img;
    var off = +row.getAttribute('data-dd-px-off') || 0;
    if (pr && off) pr.innerHTML = '<s class="dd-px__was">' + money(row, x.p * qty) + '</s> ' + money(row, Math.round(x.p * qty * (100 - off) / 100));
    else if (pr) pr.textContent = money(row, x.p * qty);
  }
  function pick(row) {
    var kind = row.getAttribute('data-dd-pair'), ref = sz(row.getAttribute('data-ref')), all = vars(row), L = lang();
    var qty = 1, x = null, sel = row.querySelector('select[data-dd-x-variant]'), size = row.querySelector('[data-dd-px-size]');
    var why = row.querySelector('[data-dd-px-why]'), q = row.querySelector('[data-dd-px-qty]'), w = '';
    if (kind === 'dekbed') {
      var list = all.filter(function (v) { var s = sz(v.s); return s && (!ref || (s.w === ref.w && s.L[0] <= Math.max.apply(null, ref.L))); });
      if (ref) {
        list.sort(function (a, b) { var ia = ref.L.indexOf(sz(a.s).L[0]), ib = ref.L.indexOf(sz(b.s).L[0]); return (ia < 0 ? 9 : ia) - (ib < 0 ? 9 : ib); });
        x = list[0] || null;
      } else if (sel) {
        var keep = sel.value; sel.innerHTML = '';
        list.forEach(function (v) { opt(sel, v, cm(v.s) + ' – ' + money(row, v.p)); });
        sel.value = keep || ((list.filter(function (v) { return /^140x200/.test(String(v.s).replace(/\s/g, '')); })[0] || list[0] || {}).id);
        if (sel.selectedIndex < 0) sel.selectedIndex = 0;
        x = sel.selectedOptions[0] && sel.selectedOptions[0].__x;
      }
      if (size && x) size.textContent = ref ? cm(x.s) : '';
    } else if (kind === 'overtrek' && sel && ref) {
      var prev = sel.selectedOptions[0] && sel.selectedOptions[0].getAttribute('data-c'), seen = {};
      var fit = all.filter(function (v) { var s = sz(v.s); return s && s.w === ref.w && Math.max.apply(null, s.L) >= ref.L[0]; });
      fit.sort(function (a, b) { return (sz(a.s).L.indexOf(ref.L[0]) < 0) - (sz(b.s).L.indexOf(ref.L[0]) < 0); });
      sel.innerHTML = '';
      fit.forEach(function (v) { if (seen[v.c]) return; seen[v.c] = 1; opt(sel, v, (v.cl || v.c) + ' – ' + money(row, v.p)); });
      var o = [].filter.call(sel.options, function (o) { return o.getAttribute('data-c') === prev; })[0] || sel.options[0];
      if (o) { sel.value = o.value; x = o.__x; }
      if (size && x) size.textContent = cm(sz(x.s).w + 'x' + sz(x.s).L.join('/'));
    } else if (kind === 'sloop' && sel) {
      // Chenille-kussenslopen (31-10-2026): data-ref = kleur van het dekbed; kleur blijft kiesbaar.
      var want = String(row.getAttribute('data-ref') || '').toLowerCase(), seenC = {};
      sel.innerHTML = '';
      all.forEach(function (v) { if (seenC[v.c]) return; seenC[v.c] = 1; opt(sel, v, (v.cl || v.c) + ' – ' + money(row, v.p)); });
      var oc = [].filter.call(sel.options, function (o) { return String(o.getAttribute('data-c')).toLowerCase() === want; })[0] || sel.options[0];
      if (oc) { sel.value = oc.value; x = oc.__x; }
    } else if (kind === 'hoeslaken' && sel) {
      // Hoeslaken (01-11-2026, upsell "Maak je bed compleet −15%"): maat en kleur kiezen; standaard 160x200 in wit.
      var keepH = sel.value, n160 = function (v) { return /(^|\/)160(\/\d+)?x200/.test(String(v.s).toLowerCase().replace(/\s|cm/g, '')); };
      sel.innerHTML = '';
      all.forEach(function (v) { opt(sel, v, [v.s ? cm(v.s) : '', v.cl || v.c || ''].filter(Boolean).join(' · ') + ' – ' + money(row, v.p)); });
      var defH = all.filter(function (v) { return n160(v) && /wit|white|wei/i.test(v.cl || v.c || ''); })[0] || all.filter(n160)[0] || all[0];
      sel.value = keepH || (defH && defH.id);
      if (sel.selectedIndex < 0) sel.selectedIndex = 0;
      x = sel.selectedOptions[0] && sel.selectedOptions[0].__x;
    } else if (kind === 'kussen') {
      var k = (ref && ref.k) || '60x70';
      qty = ref ? (ref.n || (ref.w <= 140 ? 1 : 2)) : 1;
      x = all.filter(function (v) { return String(v.s).toLowerCase().replace(/\s|cm/g, '') === k; })[0] || null;
      if (!x && all.length === 1 && !all[0].s) x = all[0]; // kussen zonder maatoptie (Goozzy-donskussen, 30-10-2026)
      if (size) size.textContent = x && x.s ? cm(k) : '';
      if (ref && ref.n) w = { nl: ref.n > 1 ? 'voor de ' + ref.n + ' slopen in je set' : 'voor de sloop in je set', de: ref.n > 1 ? 'für die ' + ref.n + ' Bezüge im Set' : 'für den Bezug im Set', en: ref.n > 1 ? 'for the ' + ref.n + ' pillowcases in your set' : 'for the pillowcase in your set' }[L];
      else if (qty > 1) w = { nl: 'een voor ieder', de: 'eins für jeden', en: 'one each' }[L];
    }
    if (why) why.textContent = w;
    if (q) q.textContent = qty > 1 ? qty + '× ' : '';
    row.setAttribute('data-dd-x-qty', qty);
    if (x) show(row, x, qty);
    row.hidden = !x;
    var box = row.closest('.dd-bb-complete, [data-dd-pairs]');
    if (box) box.hidden = !box.querySelector('[data-dd-x]:not([hidden])');
  }
  function run() {
    document.querySelectorAll('[data-dd-pair]').forEach(function (r) { if (!r.__done && r.getAttribute('data-dd-pair') !== 'vast') { r.__done = 1; pick(r); } });
    // Winkelwagen-carrousel: altijd bij de eerste kaart beginnen (scroll-snap blijft anders op de kaart die eerst zichtbaar was)
    document.querySelectorAll('.dd-px-cart__track').forEach(function (t) {
      if (t.__done) return; t.__done = 1;
      requestAnimationFrame(function () {
        t.scrollLeft = 0;
        var nav = t.parentNode.querySelector('.dd-px-cart__nav'); if (nav) nav.hidden = t.scrollWidth <= t.clientWidth + 4;
      });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dd-px-nav]'); if (!b) return;
    var t = b.closest('[data-dd-pairs]').querySelector('.dd-px-cart__track'), c = t && t.querySelector('[data-dd-x]:not([hidden])');
    if (t && c) t.scrollBy({ left: (+b.getAttribute('data-dd-px-nav')) * (c.offsetWidth + 10), behavior: 'smooth' });
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-dd-pair] select[data-dd-x-variant]')) {
      var row = t.closest('[data-dd-pair]'), o = t.selectedOptions[0];
      if (o && o.__x) { show(row, o.__x, +row.getAttribute('data-dd-x-qty') || 1); if (row.getAttribute('data-dd-pair') === 'dekbed') { var s = row.querySelector('[data-dd-px-size]'); if (s) s.textContent = ''; } }
      return;
    }
    if (t.matches && t.matches('input[type=radio]') && /^(size|maat|afmeting|größe|grösse|bedding size)/i.test(t.name || '')) {
      document.querySelectorAll('.dd-bb-complete [data-dd-pair]').forEach(function (r) { if (r.getAttribute('data-ref') && r.getAttribute('data-dd-pair') !== 'sloop') { r.setAttribute('data-ref', t.value); pick(r); } });
    }
    if (t.matches && t.matches('input[type=radio]') && /^(color|colour|kleur|farbe)/i.test(t.name || '')) {
      document.querySelectorAll('.dd-bb-complete [data-dd-pair="sloop"]').forEach(function (r) { r.setAttribute('data-ref', t.value); pick(r); });
    }
  });
  var tm; new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(run, 30); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();

/* Pre-order (30-10-2026, backorders Goozzy): zie snippets/dd-preorder.liquid. Wisselt de melding, de voorraadregel ("Op voorraad" ↔
   "Pre-order") en de bezorgtijdlijn mee met de gekozen variant. Geen datum: de voorraad moet nog binnenkomen. */
(function () {
  if (window.__ddPre) return;
  window.__ddPre = true;
  function ids() {
    var el = document.querySelector('[data-dd-pre]');
    if (!el) return null;
    try { return JSON.parse(el.textContent).map(String); } catch (e) { return null; }
  }
  function current() {
    var inp = document.querySelector('.product__info-wrapper form[action*="/cart/add"] input[name="id"], product-form form[action*="/cart/add"] input[name="id"]');
    var v = inp && inp.value;
    if (!v) { var m = location.search.match(/[?&]variant=(\d+)/); v = m && m[1]; }
    return v ? String(v) : '';
  }
  function apply() {
    var list = ids();
    if (!list) return;
    var pre = list.indexOf(current()) > -1;
    var note = document.querySelector('[data-dd-pre-note]');
    if (note) note.hidden = !pre;
    var li = document.querySelector('[data-dd-stock]');
    if (li) {
      if (!li.__c) li.__c = li.classList.contains('is-out') ? 'is-out' : 'is-ok';
      li.classList.toggle('is-pre', pre);
      li.classList.toggle(li.__c, !pre);
      var a = li.querySelector('.dd-st-in'), b = li.querySelector('.dd-st-pre');
      if (a) a.hidden = pre;
      if (b) b.hidden = !pre;
    }
    document.querySelectorAll('[data-dd-gd]').forEach(function (el) { el.hidden = pre; });
  }
  document.addEventListener('change', function () { setTimeout(apply, 60); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) setTimeout(apply, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();
